import React, { useEffect, useState, useRef, memo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { EnhancedProductCard } from '../shared/EnhancedProductCard';
import { ClockIcon, ZapIcon, ArrowRightIcon } from 'lucide-react';
import { PRODUCT_IMAGES } from '../../data/productImages';
import { useHorizontalScroll } from '../../lib/hooks/useHorizontalScroll';
import { haptics } from '../../lib/utils/haptics';
export const DealOfTheDay = memo(function DealOfTheDay() {
  const [searchParams] = useSearchParams();
  const isNowContext = searchParams.get('from') === 'now';
  const {
    scrollContainerRef,
    currentSlide,
    isMobile,
    handleScroll,
    scrollToSlide
  } = useHorizontalScroll();
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 45,
    seconds: 30
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        if (seconds > 0) {
          seconds--;
        } else {
          seconds = 59;
          if (minutes > 0) {
            minutes--;
          } else {
            minutes = 59;
            if (hours > 0) {
              hours--;
            }
          }
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const products = [{
    id: 1,
    name: 'Premium Protein Powder 5lb',
    brand: 'Optimum Nutrition',
    price: 49.99,
    originalPrice: 89.99,
    discount: 44,
    rating: 4.9,
    reviewCount: 3456,
    image: PRODUCT_IMAGES[0],
    isBestSeller: true,
    isNew: false,
    expressDelivery: true
  }, {
    id: 2,
    name: 'Pre-Workout Energy Boost',
    brand: 'C4',
    price: 29.99,
    originalPrice: 49.99,
    discount: 40,
    rating: 4.7,
    reviewCount: 2103,
    image: PRODUCT_IMAGES[1],
    isBestSeller: false,
    isNew: false,
    expressDelivery: true
  }, {
    id: 3,
    name: 'BCAA Recovery Formula',
    brand: 'Scivation',
    price: 34.99,
    originalPrice: 54.99,
    discount: 36,
    rating: 4.8,
    reviewCount: 1789,
    image: PRODUCT_IMAGES[2],
    isBestSeller: false,
    isNew: true,
    expressDelivery: true
  }, {
    id: 4,
    name: 'Mass Gainer 12lb',
    brand: 'Serious Mass',
    price: 59.99,
    originalPrice: 99.99,
    discount: 40,
    rating: 4.6,
    reviewCount: 1234,
    image: PRODUCT_IMAGES[3],
    isBestSeller: false,
    isNew: false,
    expressDelivery: true
  }, {
    id: 5,
    name: 'Creatine Monohydrate',
    brand: 'MuscleTech',
    price: 24.99,
    originalPrice: 39.99,
    discount: 38,
    rating: 4.7,
    reviewCount: 987,
    image: PRODUCT_IMAGES[4],
    isBestSeller: false,
    isNew: false,
    expressDelivery: true
  }, {
    id: 6,
    name: 'Fat Burner Thermogenic',
    brand: 'Hydroxycut',
    price: 39.99,
    originalPrice: 64.99,
    discount: 38,
    rating: 4.5,
    reviewCount: 1567,
    image: PRODUCT_IMAGES[0],
    isBestSeller: false,
    isNew: false,
    expressDelivery: true
  }];
  const totalSlides = Math.ceil(products.length / (isNowContext ? 3 : 2));
  return <div className="w-full" data-id="element-2257" data-mp="37xhdl0qoxudv">
      <div className="container mx-auto px-4" data-id="element-2258" data-mp="380vfy8zcu3lb">
        <div className="bg-gradient-to-r from-orange-600 to-red-600 rounded-xl overflow-hidden mb-6" data-id="element-2259" data-mp="2abts3avrwwh4">
          <div className="p-6 md:p-8" data-id="element-2260" data-mp="2f9btmg7go9f3">
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center" data-id="element-2261" data-mp="2fadf7em3seb2">
              <div className="mb-4 md:mb-0" data-id="element-2262" data-mp="2k7ww6ma6r56p">
                <span className="text-xs font-bold text-white bg-white bg-opacity-20 px-2 py-0.5 rounded-full mb-2 inline-block uppercase" data-id="element-2263" data-mp="2obbb19me1fik">
                  24 HOUR SPECIAL
                </span>
                <h2 className="text-2xl md:text-3xl font-bold text-white flex items-center" data-id="element-2264" data-mp="3k1ck20wrv6s">
                  <ZapIcon className="w-6 h-6 md:w-8 md:h-8 mr-2" data-id="element-2265" data-mp="235ifw7cdfmy" />
                  Deal of the Day
                </h2>
              </div>
              <div className="flex items-center gap-4" data-id="element-2266" data-mp="3tb9iclgq3wbq">
                <div className="flex items-center gap-2 bg-white bg-opacity-20 rounded-full px-4 py-2" data-id="element-2267" data-mp="c1bcxsqtjjhs">
                  <ClockIcon className="w-4 h-4 text-white" data-id="element-2268" data-mp="71ystfrc0qiw" />
                  <div className="flex items-center gap-1 font-mono font-bold text-white" data-id="element-2269" data-mp="74l2bkxs9g3r">
                    <span data-id="element-2270" data-mp="l06m9dp5t9pb">{String(timeLeft.hours).padStart(2, '0')}</span>
                    <span data-id="element-2271" data-mp="g2ewoqbzlzoa">:</span>
                    <span data-id="element-2272" data-mp="g1c5sienzx8d">{String(timeLeft.minutes).padStart(2, '0')}</span>
                    <span data-id="element-2273" data-mp="urjggbyfkbyi">:</span>
                    <span data-id="element-2274" data-mp="pszq7zct0e0c">{String(timeLeft.seconds).padStart(2, '0')}</span>
                  </div>
                </div>
                <a href="#" className="hidden md:flex text-white bg-white bg-opacity-20 hover:bg-opacity-30 px-4 py-2 rounded-full text-sm font-medium transition-colors items-center" data-id="element-2275" data-mp="13s960xx3l63s">
                  View All
                  <ArrowRightIcon className="w-4 h-4 ml-1" data-id="element-2276" data-mp="1idddbgsiccfh" />
                </a>
              </div>
            </div>
          </div>
        </div>
        {/* Mobile Slider */}
        {isMobile ? <div className="relative" data-id="element-2277" data-mp="19gvzu6wo82gk">
            <div ref={scrollContainerRef} onScroll={handleScroll} className="flex overflow-x-auto snap-x snap-mandatory scrollbar-hide gap-3" style={{
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
          WebkitOverflowScrolling: 'touch'
        }} data-id="element-2278" data-mp="1edctthqjxb1k">
              {products.map(product => <div key={product.id} className="snap-start flex-shrink-0" style={{
            width: isNowContext ? 'calc(33.333% - 8px)' : 'calc(50% - 6px)'
          }} data-id="element-2279" data-mp="uqx225912t1m">
                  <EnhancedProductCard product={product} data-id="element-2280" data-mp="2necuits4h9os" />
                </div>)}
            </div>
            {/* Pagination Dots */}
            <div className="flex justify-center gap-2 mt-4" data-id="element-2281" data-mp="2imuuq91u5f5e">
              {Array.from({
            length: totalSlides
          }).map((_, index) => <button key={index} onClick={() => scrollToSlide(index)} className={`h-2 rounded-full transition-all ${currentSlide === index ? 'w-6 bg-[#1E2B55]' : 'w-2 bg-gray-300'}`} aria-label={`Go to slide ${index + 1}`} data-id="element-2282" data-mp="29nhsa0c4pqu6" data-mpi={index} />)}
            </div>
          </div> :
      // Desktop Grid
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4" data-id="element-2283" data-mp="2sdzavc38z61t">
            {products.map(product => <EnhancedProductCard key={product.id} product={product} data-id="element-2284" data-mp="1lyyjzkt2xe23" />)}
          </div>}
      </div>
    </div>;
});